mainApp.component('slaSettingsLastResort', {
    templateUrl: '/public/components/configuration/slaSettings/sla-settings-last-resort-configuration.component.html',
    bindings: {
        model: '=',
        siteId: '<?',
        showOverrideCheckbox: '<?',
    },
    controller: slaSettingsLastResortConfigurationController
});


function slaSettingsLastResortConfigurationController() {
    const ctrl = this;

    ctrl.disableInput = () => {
        return ctrl.siteId && !ctrl.model?.overrideAccountLastResortSettings;
    }
};
